<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    KPI
                </v-card-title>

                <v-card-text>
                  <v-data-table
                    :headers="headers"
                    :items="KPI"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.kpi_name }}</td>
                      <td class="text-xs-left">{{ props.item.kpi_value}}</td>

                      <td><v-switch v-model="props.item.show_flag" @change="trigger(props.item.kpi_id,props.item.show_flag)" :disabled="!$can('update', 'KPI')"></v-switch></td>
                      <td class="text-xs-left" :disabled="!$can('delete', 'KPI')">
                          <v-btn icon @click="delete(item.kpi_id)">
                              <v-icon style="color:darkgrey">fa-trash</v-icon>
                          </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import {getKPI, putKPI,deleteKPI} from '@/helper'
  export default {
    data () {
      return {
        headers: [
          {
            text: 'KPI ',
            align: 'left',
            sortable: true,
            value: 'KPI'
          },
          { text: 'Value ', value: 'value', sortable: false },
          { text: 'Show on Dashboard ', switch1: true, sortable: false },
            { text: 'Actions ', value: 'name', sortable: false }
        ],
        KPI: [ ]
      }
    },
    methods: {
      async trigger(id, state) {
        await putKPI(
          {
            'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,
            'kpi_id': id,
            'show_flag': state
          }
        )
      },
      async refresh() {
        let res = await getKPI(
          {'facility_name': this.$store.state.pointsListStore.pointsList.facility_name}
        )
        this.KPI = res['result']
      },
      async delete(id) {
        await deleteKPI(
          {'kpi_id': id}
        )
        this.refresh()
      }
    },
    mounted () {
      this.refresh()
    }
  }
</script>

<style scoped>

</style>
